module.exports = __webpack_public_path__ + "static/media/sharkfriends.01d29a60.png";